<template>
  <div id="app">
    <template>
      <el-backtop target="#app">
        <div class="back-ball">
          回到顶部
        </div>
      </el-backtop>
    </template>
    <router-view></router-view>
  </div>
</template>
<script>
// import header from '@/components/AXheader.vue'
// import AXfooter from '@/components/AXfooter.vue'
// import AXbanner from './views/components/AXbanner.vue'
// import AXcontent from './views/components/AXcontent.vue'
export default {
  components: {
    // 'ax-header': header,
    // 'ax-footer': AXfooter,
    // 'ax-banner': AXbanner,
    // 'ax-content': AXcontent,
  }
}
</script>

<style>
*{
  margin: 0;
  padding: 0
}
html,body{
  height: 100%;
}
li{
  list-style: none;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size: 14px;
  background: #F4F4F4;
}
</style>
